import { AutomotiveAftermarketTileType } from '../../store/state/monitoring/automotive-aftermarket/constants/automotive-aftermarket-list-filters.constant';
import { AutomotiveAftermarketTypeView } from '../../store/state/monitoring/automotive-aftermarket/models/automotive-aftermarket-list.model';
import type { AutomotiveAftermarketTypeViewType } from '../../store/state/monitoring/automotive-aftermarket/models/automotive-aftermarket-list.model';
import { Permission } from '../constants/permissions';

export function convertTileType(
  tileType: { [key in AutomotiveAftermarketTileType]: boolean },
  tileTypePermissions: { [key in Permission]: boolean },
): AutomotiveAftermarketTypeViewType[] {
  return Object.keys(tileType)
    .filter(
      (key: AutomotiveAftermarketTileType) =>
        tileType[key] &&
        tileTypePermissions[
          Permission[
            Object.keys(AutomotiveAftermarketTileType)[Object.values(AutomotiveAftermarketTileType).indexOf(key)]
          ]
        ],
    )
    .map((tileTypeKey: string) => AutomotiveAftermarketTypeView[tileTypeKey.toUpperCase()[0] + tileTypeKey.slice(1)]);
}
